/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, in regular-expression mode. Wrap part of your pattern in parentheses to capture it, then reference it in the replacement with $1 for the first group (or $& for the whole match). In literal mode the replacement is inserted as-is.`)
};

const es_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, en modo de expresión regular. Envuelve parte de tu patrón entre paréntesis para capturarlo, luego referencialo en el reemplazo con $1 para el primer grupo (o $& para toda la coincidencia). En modo literal, el reemplazo se inserta tal cual.`)
};

const de_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, im Regex-Modus. Setzen Sie einen Teil Ihres Musters in Klammern, um ihn zu erfassen, und verweisen Sie dann in der Ersetzung mit $1 auf die erste Gruppe (oder $& auf die gesamte Übereinstimmung). Im wörtlichen Modus wird die Ersetzung unverändert eingefügt.`)
};

const nl_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, in de modus voor reguliere uitdrukkingen. Wrap deel van uw patroon in haakjes om het vast te leggen, en verwijs er in de vervanging naar met $1 voor de eerste groep (of $& voor de volledige overeenkomst). In letterlijke modus wordt de vervanging ongewijzigd ingevoegd.`)
};

const fr_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, en mode expression régulière. Entourez une partie de votre modèle entre parenthèses pour le capturer, puis référencez-le dans le remplacement avec $1 pour le premier groupe (ou $& pour la correspondance entière). En mode littéral, le remplacement est inséré tel quel.`)
};

const it_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, in modalità espressione regolare. Racchiudi parte del tuo modello tra parentesi per acquisirlo, quindi fai riferimento ad esso nella sostituzione con $1 per il primo gruppo (o $& per l'intera corrispondenza). In modalità letterale la sostituzione viene inserita così com'è.`)
};

const pt_br2_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, no modo de expressão regular. Envolva parte do seu padrão entre parênteses para capturá-lo, em seguida, referencie-o na substituição com $1 para o primeiro grupo (ou $& para toda a correspondência). No modo literal, a substituição é inserida como está.`)
};

const pt_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, em modo de expressão regular. Coloque parte do seu padrão entre parênteses para capturá-lo e, em seguida, faça referência a ele na substituição com $1 para o primeiro grupo (ou $& para toda a correspondência). Em modo literal, a substituição é inserida como está.`)
};

const ja_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、正規表現モードで可能です。パターンの一部を括弧で囲んで取得し、置換で $1 を使用して最初のグループを参照します（または $& は全体のマッチの場合）。リテラルモードでは、置換はそのまま挿入されます。`)
};

const zh_fr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以，在正则表达式模式下。将模式的一部分用括号括起来即可捕获它，然后在替换内容中使用 $1 引用第一个分组（或使用 $& 引用整个匹配项）。在字面模式下，替换内容会按原样插入。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq4_a", locale)
	if (locale === "en") return en_fr_faq4_a(inputs)
	if (locale === "es") return es_fr_faq4_a(inputs)
	if (locale === "de") return de_fr_faq4_a(inputs)
	if (locale === "nl") return nl_fr_faq4_a(inputs)
	if (locale === "fr") return fr_fr_faq4_a(inputs)
	if (locale === "it") return it_fr_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq4_a(inputs)
	if (locale === "pt") return pt_fr_faq4_a(inputs)
	if (locale === "ja") return ja_fr_faq4_a(inputs)
	return zh_fr_faq4_a(inputs)
};